<div>

    <p style="font-size: 24px;
    font-weight: 500;
    margin-bottom: 0px !important;
    color: #424242;">Error Report  <button (click)="dialogRef.close()" style="float: right;
    border: 0;
    color: #424242;
    background: #eeeeee;"><i class="fa-solid fa-xmark"></i></button> </p>
    <p style="color: #acacac;">{{location.street_address}}</p>

    <div id="display" style="padding: 8px;max-height: 320px;
    overflow-y: scroll; ">

        <div *ngIf="errors.length < 1" @fadeIn style="color:#424242">
            
            <div style="padding: 16px; line-height:1.5em;">
                <p style="margin:0;
                font-size: 20px;
                letter-spacing: 0.2px;">This form is for reporting errors for a location. Use the section below to enter the first error.</p>
            </div>

        </div>



        <div *ngFor="let error of errors.slice().reverse()" @fadeIn style="color:#424242;">
            <div style="padding: 16px; line-height:1.5em;">
                <p style="margin:0;
                /* padding: 16px; */
                font-size: 20px;
                letter-spacing: 0.2px;">{{error.description}}</p>
            </div>
            <div style="padding:16px;">
                <p style="line-height: 0;">{{error.created_at.substring(0,10)}}<span style="color: #a4a4a4;
                    margin-left: 1em;">{{error.employee_name}}</span></p>
            </div>
            <div>
                <p>{{error.errortype}}: {{error.committed_by}}</p>
            </div>
        </div>


    </div>

    <div id="addContainer" style="display: flex;
    flex-direction: column;
    position: absolute;">
        <div>
            <p style="font-size: 24px;
            font-weight: 500;
            margin-bottom: 0px !important;
            color: #424242;">New Error</p>
        </div>

        <div id="addNew" style="width: 100%">
            <div style="display: flex;
            align-items: center;
            padding-bottom: 20px;">
                <textarea class="custom-textarea" id="description" placeholder="Enter the error details here" [(ngModel)]="description"></textarea>
            </div>
            <div *ngIf="description">
                <button (click)="addError()" class="errorAddButton">Add</button>
                <select [(ngModel)]="errorType" style="margin-left: 16px;
                border: 0px;
                border-radius: 0.5em;
                background: white;
                height: 3.8em;
                width: 10em;
                padding-left: 1em;
                font-weight: 700;
                color: #424242;">
                    <option value="General" selected>General</option>
                    <option value="Modeler">Modeler</option>
                </select>
            </div>
            <div *ngIf="errorType == 'Modeler'">
                <select [(ngModel)]="selectedmodeler" style="
                border: 0px;
                border-radius: 0.5em;
                background: white;
                height: 3.8em;
                width: 18.5em;
                padding-left: 1em;
                font-weight: 700;
                color: #424242;
                margin-top: 1em;">
                    <option *ngFor="let emp of employees" [value]="emp.employee_name">{{emp.employee_name}}</option>   
                </select>
            </div>


        </div>

    </div>


</div>